import { cn } from '../../helpers'
import { type ReactNode } from 'react'

export interface JosefContainerProps {
  children: ReactNode
  className?: string
}

export function JosefContainer({
  children,
  className = '',
}: JosefContainerProps) {
  return (
    <div className={cn('px-2 pb-2 h-screen flex flex-col space-y-2', className)}>
      {children}
    </div>
  )
}

export default JosefContainer
